/* PREbiotic Product Spotlight LP behaviour.
   Loaded with `defer` so it runs after the whole template is parsed - the
   anchor resolver below needs the buy-box section to already exist. */
(function () {
  if (window.__pbsInit) return; // section renders 3x on the page; run once
  window.__pbsInit = true;

  function init() {
    // Click-to-load YouTube facade: no third-party JS until the user asks for it.
    document.querySelectorAll('[data-pbs-video]').forEach(function (el) {
      el.addEventListener('click', function () {
        var id = el.getAttribute('data-pbs-video');
        if (!id) return;
        var f = document.createElement('iframe');
        f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('title', el.getAttribute('aria-label') || 'Video');
        f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        el.innerHTML = '';
        el.appendChild(f);
      }, { once: true });
    });

    // On a JSON template, section ids render as shopify-section-template--NNN__key,
    // so a hand-written #shopify-section-key anchor never resolves. Point those at
    // whatever the section actually rendered as.
    document.querySelectorAll('.pbs-cta__btn[href^="#"]').forEach(function (a) {
      var hash = a.getAttribute('href').slice(1);
      if (!hash || document.getElementById(hash)) return;
      var key = hash.replace(/^shopify-section-/, '');
      var target = document.querySelector('[id$="__' + key + '"]');
      if (target) a.setAttribute('href', '#' + target.id);
    });

    // Never upscale a small source image past its natural width.
    document.querySelectorAll('.pbs-media img').forEach(function (img) {
      var clamp = function () {
        var w = img.naturalWidth;
        if (w && w < 700 && !img.parentElement.style.maxWidth) {
          img.parentElement.style.maxWidth = w + 'px';
          img.parentElement.style.marginLeft = 'auto';
          img.parentElement.style.marginRight = 'auto';
        }
      };
      if (img.complete) clamp();
      else img.addEventListener('load', clamp, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
